export const FOOTER_HEIGHT = 88;
export const FOOTER_MOBILE_HEIGHT = 127;
